import { AbstractControl, ValidationErrors } from '@angular/forms';

export function MapScaleValidator(
  control: AbstractControl,
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  let invalid = false;
  control.value
    .split(',')
    .map((s: string) => {
      return s.trim();
    })
    .forEach((element: string) => {
      if (!invalid) {
        invalid = !/^[0-9]+$/.test(element); // Invalid if the element isn't numeric
      }
    });

  return invalid ? { nonNumericElement: true } : null;
}
